import React, { useContext, useEffect, useState } from "react";
import {
  ManagePlanLayout,
  CsplTable as Table,
  AddPlans,
  LoaderWrapper,
  Select,
} from "../../../components";
import { isEmpty, get } from "lodash";
import { Link } from "react-router-dom";
import {
  getPathWithParam,
  MANAGE_PLAN_ROUTES,
  FLOW_TYPES,
  toOptionValuesFromMapper,
} from "../../../utils";
import { IRSCategory } from "../../../utils/constants/common";
import { Field } from "formik";
import { useRequest, useRouterParams } from "../../../abstracts";
import { createPlanStore } from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";
import moment from "moment";
import { getIRSLimits } from "../../../services";

const columns = [
  {
    label: "IRS Limit",
    className: "column-irslimit",
    columnName: "irslimit",
  },
  {
    label: "Year 1",
    className: "column-year1",
    columnName: "year1",
  },
  {
    label: "Year 2",
    className: "column-year2",
    columnName: "year2",
  },
  {
    label: "custom",
    className: "column-customyear",
    columnName: "customyear",
  },
];

const IRSLimits = (props) => {
  const { planId } = useRouterParams();
  const [customYear, setCustomYear] = useState(moment().year() - 2);
  const [year, setYear] = useState({});
  const [response, setResponse] = useState([]);
  useEffect(() => {
    var y = {};
    for (var i = moment().year() - 2; i > 2011; i--) {
      y[i] = i;
    }
    setYear(y);
    getIRSLimits(parseInt(planId)).then((response) => {
      setResponse(response);

      setCustomYear(
        response[0].limits.length > 1
          ? response[0]?.limits[0]?.year - 2
          : response[0]?.limits[0]?.year
      );
      if (response[0].limits.length > 1) {
        for (var i = response[0]?.limits[0]?.year - 2; i > 2011; i--) {
          y[i] = i;
        }
        setYear(y);
      } else {
        setYear(response[0]?.limits[0]?.year);
      }
    });
  }, []);
  // const { response: response, loading: load } = useRequest({
  //   method: getIRSLimits,
  //   defaultResponse: [],
  //   payload: planType
  // });
  const buttons = [];

  const handleChange = (e) => {
    setCustomYear(e.target.value);
  };
  return (
    <ManagePlanLayout buttons={buttons}>
      {!isEmpty(response) && (
        <LoaderWrapper>
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading"></div>
            </div>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    if (item.label == "custom" && response[0].limits.length > 2)
                      return (
                        <Table.Th key={index} className={item.className}>
                          <Select
                            className="bg-transparent p-0 no-caret"
                            label="Select"
                            title={customYear}
                            optionsList={toOptionValuesFromMapper(year)}
                            onClick={handleChange}
                            value={customYear}
                            isNotTypeAhead
                            isRadio
                          />
                        </Table.Th>
                      );
                    if (item.label != "IRS Limit") {
                      return index <= response[0].limits.length ? (
                        <Table.Th key={index} className={item.className}>
                          {response[0]?.limits[0]?.year - index + 1}
                        </Table.Th>
                      ) : null;
                    } else
                      return (
                        <Table.Th key={index} className={item.className}>
                          {item.label}
                        </Table.Th>
                      );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {response.map((category, index) => {
                  return (
                    <Table.Tr key={index}>
                      <Table.Td className="column-custodianName">
                        {IRSCategory[category.irsCategory]}
                      </Table.Td>

                      <Table.Td
                        className="column-custodianMail"
                        style={{ textAlign: "right" }}
                      >
                        {category.limits[0]?.irsLimit}
                      </Table.Td>

                      {category.limits.length > 1 ? (
                        <Table.Td
                          className="column-custodianMail"
                          style={{ textAlign: "right" }}
                        >
                          {category.limits[1]?.irsLimit}
                        </Table.Td>
                      ) : null}
                      {category.limits.length > 2 ? (
                        <Table.Td
                          className="column-custodianMail"
                          style={{ textAlign: "right" }}
                        >
                          {
                            category.limits[
                              response[0]?.limits[0]?.year - customYear
                            ]?.irsLimit
                          }
                        </Table.Td>
                      ) : null}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        </LoaderWrapper>
      )}
    </ManagePlanLayout>
  );
};

export default IRSLimits;
